import pullUp from 'src/images/pull-up.png';
import pushUp from 'src/images/push-up.png';
import squat from 'src/images/squat.png';

interface IHealth {
  id: number;
  image: string;
  title: string;
  shortDescription: string;
  description: string;
  epectation: string;
  x: number;
  y: number;
  color: string;
}

const healthList: IHealth[] = [
  {
    id: 1,
    image: pushUp,
    title: '팔굽혀펴기 (push up)',
    shortDescription:
      '엎드린 자세에서 어깨에서 발끝까지 일직선을 이루도록 몸을 고정 후 팔굽치를 굽혔다 펴는 운동입니다.',
    description:
      '대흉근, 삼두근, 전면/측면 삼각근, 복근, 전거근, 광배근 등의 근육 사용합니다. 일반적으로 대흉근에 자극 효과를 주나  어깨를 좁게 할시 전거근과 삼두근에 자극 증가를 시킬수 있습니다. ',
    epectation:
      '상체, 가슴 근육과 더불어 전신의 코어 근육들을 군형감 있게 단련시켜주는 운동입니다. 복합 운동으로써 칼로리를 태우고 근육량을 늘리며, 다이어트에 도움이 되며, 체지방을 감소 시키며, 근육질 몸매를 만들 수 있습니다. 또한, 심장을 건강하게 만들기 때문에 심혈관계를 강화하는 효과를 얻을 수 있습니다.',
    x: 60,
    y: 80,
    color: '#f45ab9',
  },
  {
    id: 2,
    image: pullUp,
    title: '턱걸이 (pull up)',
    shortDescription:
      '풀 업은 손등을 자기 방향으로 향하게 하여 철봉은 손으로 잡고 당겨 턱을 철봉 위까지 끌어 올리는 운동입니다.',
    description:
      '철봉바를 강하게 쥐는 전완근의 힘 상승과 숄더 패킹을 유지하기 위한 중하부 승모근 힘 상승위한 운동입니다. 상완 이두근의 고효율 운동이며, 또한  광배근의 자극을 극대화 시킨 운동이라 할 수 있습니다.',
    epectation:
      '풀업은 상체 전반을 단련하는 운동이고 등 근육을 발달 시키기 위해서는 반드시 들어가는 필수 운동으로 그 중요성과 효율성으로 최고의 맨 몸 운동이라 할 수 있습니다. 숙련된다면 어깨와 등이 넓어지고 상체가 커 보이는 효과를 가지고 있습니다.',
    x: 120,
    y: 80,
    color: '#ffa81c',
  },
  {
    id: 3,
    image: squat,
    title: '스쿼트 (squat)',
    shortDescription:
      '웨이트 트레이닝의 대표적인 운동이며, 무릎 관절을 굽혔다 펴는 행동을 반복함으로써, 하반신 근육을 성장 시킵니다.',
    description:
      '대퇴사두근, 햄스트링, 내전근, 척추기립근, 승모근을 포함한 다리 근육을 만드는데 도움을 주는 운동입니다.',
    epectation:
      '대 전체 근육 구축을 촉진하는 환경을 조성해주며 근육 성장에 필요한 호로몬을 증가 시키며 스쿼트의 반복 움직임은 체내 혈액의 펌핑으로 인한 노폐물 제거 효과 및 코어 근육, 인대 몇 결합 조직 등을 강화 시켜주는 효과가 있습니다. 많은 근육을 사용하고 체중을 이겨낼 힘이 필요하므로 그만큼 칼로리의 소모가 많은데 그러므로 지방을 태우는데 효율적인 운동입니다.',
    x: 180,
    y: 80,
    color: '#17de14',
  },
];

export default healthList;
